'use client';
import React, { useCallback, useState } from 'react';
import Sidebar from '@/components/Sidebar';
import Topbar from '@/components/Topbar';
import AppToaster from '@/components/ui/Toast';
import RouteGuard from '@/components/RouteGuard';

interface AppLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

export default function AppLayout({ title, subtitle, children }: AppLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const toggleCollapse = useCallback(() => setCollapsed((v) => !v), []);
  const closeMobile = useCallback(() => setMobileOpen(false), []);
  const openMobile = useCallback(() => setMobileOpen(true), []);

  return (
    <RouteGuard>
      <div className="min-h-screen bg-background">
        <Sidebar
          collapsed={collapsed}
          onToggleCollapse={toggleCollapse}
          mobileOpen={mobileOpen}
          onCloseMobile={closeMobile}
        />
        <div className={`transition-all duration-300 ease-in-out ${collapsed ? 'lg:pl-[72px]' : 'lg:pl-[260px]'}`}>
          <Topbar title={title} subtitle={subtitle} onOpenMobile={openMobile} />
          <main className="mx-auto w-full max-w-screen-2xl px-4 py-6 md:px-6 lg:px-8 xl:px-10 2xl:px-16">{children}</main>
        </div>
        <AppToaster />
      </div>
    </RouteGuard>
  );
}